import { WidgetWrapper } from '../components/WidgetWrapper';

interface Props {
  readonly title?: string;
  readonly text?: string;
  readonly children: any;
}

export function WrapperWidget(props: Props) {
  return (
    <WidgetWrapper
      title={props.title}
      text={props.text}
    >
      {props.children}
    </WidgetWrapper>
  );
}
